module.exports = __webpack_public_path__ + "assets/projects/maria-jose-moreno/project-header.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/maria-jose-moreno/project-header.jpg
// module id = 49
// module chunks = 0